import type { GetFaqResponse } from './faq'

export const getFaqMock: GetFaqResponse = {
  questions: [
    {
      title: 'What are refurbished devices?',
      text: 'Refurbished is not the same thing as used or secondhand. The sellers we partner with are held to rigorous quality guidelines that ensure every item we sell runs like new. The refurbishment process they adhere to includes meticulously cleaning, testing, and assessing every item, as well as replacing aging parts with high-quality new components. Meanwhile, with secondhand or used items, you’re left to the private seller’s good word as to their true condition, and with no guarantee or warranty.',
    },
    {
      title: 'What does the 12 months warranty cover?',
      text: "This warranty is limited to technical defects and component issues that affect the functionality of your item. It doesn't cover accidental breakage or compatibility and software upgrade issues, so make sure you read up about the limits of older models and check your phone carrier's website for models they don't support.",
    },
    {
      title: 'Will I be able to update the software on this phone?',
      text: 'Yes! This device is compatible with the latest software updates.',
    },
    {
      title: 'Which payment methods are available?',
      text: 'We accept Visa, MasterCard, Discover, and American Express. PayPal and Affirm are also options if offered by the seller. We don’t accept payments via bank transfer, check, or cash.',
    },
    {
      title: "What's the Back Market Quality Assurance Fee for?",
      text: 'This fee allows us to vet and monitor the sellers we partner with, ensuring they meet our rigorous quality and customer-service standards. Your happiness is our top priority!',
    },
  ],
}
